
export const generateUniqueString = () => {
    const timestamp = Date.now().toString(36);
    const randomPart = Math.random().toString(36).substring(2, 10);
    return btoa(`${timestamp}-${randomPart}`).replace(/=+$/, '');
}
export const generateUniqueString = () => {
    const timestamp = Date.now().toString(36);
    const randomPart = Math.random().toString(36).substring(2, 10);
    return btoa(`${timestamp}-${randomPart}`).replace(/=+$/, '');
}